export type IResultValue = string | number | boolean | null

export interface IResultRow {
  [key: string]: IResultValue
}

export const PREVIOUS_PERIOD_SUFFIX = '__prev'
